import { app } from "../App";
import { getAuth } from "firebase/auth";
import { useNavigationHelper } from "./useNavigationHelper";
import { useSignOut } from "react-firebase-hooks/auth";
import { useState } from "react";

/**
 * Hook do zarządzania menu AppBar
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko logika menu
 */
export const useAppBarMenu = () => {
  const [signOut] = useSignOut(getAuth(app));
  const { goToMainRoot, goToAccountSettings } = useNavigationHelper();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleProfileClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSettings = () => {
    goToAccountSettings();
    handleClose();
  };

  return {
    anchorEl,
    open,
    handleProfileClick,
    handleClose,
    handleSettings,
  };
};
